<script lang="ts">
    import src from './svg/official/TruckInMove.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
    export let title: string = '';

    scale = scale * 0.68;
</script>

<TemplateIcon {src} {scale} alt={title} hover={title} on:click />
